import { render } from "./ListDepartmentsView.vue?vue&type=template&id=0d972750&scoped=true&ts=true"
import script from "./ListDepartmentsView.vue?vue&type=script&lang=ts"
export * from "./ListDepartmentsView.vue?vue&type=script&lang=ts"

import "./ListDepartmentsView.vue?vue&type=style&index=0&id=0d972750&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d972750"]])

export default __exports__